<template>
  <div class="error401">
    <div class="row">
      <!--<el-row>-->
        <!--<el-col :span="12">-->
          <h1 class="h1">Oops!</h1>
          <h4 class="h4">您没有登录！！</h4>
           <!--<h6 class="error401-row-h6">如您有任何的不满，请联系您的领导</h6>-->
          <ul>
            <!-- <li class="error401-row-li">随便看看</li> -->
            <li class="error401-row-li">
              <router-link to="/log">去登录</router-link>
              <router-link to="/">回首页</router-link>
              <!--<p @click="Name()">{{fullName}}</p>-->
              <!--&lt;!&ndash;<router-link to="/">回首页</router-link>&ndash;&gt;-->
              <!--<input type="text" v-model="firstname" @keyup="getFullname">+-->
              <!--<input type="text" v-model="lastname" @keyup="getFullname">=-->
              <!--<input type="text" v-model="fullname">-->
            </li>
          </ul>
        <!--</el-col>-->
        <!--<el-col :span="12">-->
          <!--<img :src="errGif401" width="313" height="428">-->
        <!--</el-col>-->
      <!--</el-row>-->
    </div>
  </div>
</template>

<script>

  export default {
    data () {
      return {
        firstName: 'Fo',
        lastName: 'Bar',
        fullName: 'Foo Bar',
        firstname: "",
        lastname: "",
        fullname: ""
      }
    },
    methods: {
      getFullname: function () {
//                this.fullname = this.firstname+this.lastname;
      }
    },
    watch: {
      Name: function (val) {
        console.log(val)
        this.fullName = val + ' ' + this.lastName
      },
      lastName: function (val) {
        this.fullName = this.firstName + ' ' + val
      },
      'firstname': function (newVal,oldVal) {

        console.log((newVal + "--" + oldVal));
      },
      'lastname': function (newVal,oldVal) {
        console.log((newVal + "--" + oldVal));
      }
    }
  }
</script>

<style  scoped="">
  .error401 {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    /*padding: 100px 0;*/
  }
    .row {
      width: 100%;
      /*height: 428px;*/
      margin: 0 auto;
      text-align: center;
    }
      .h1 {
        /*padding-top: 118px;*/
        color: #007A87;
        font-size: 60px;
        font-weight: 700;
      }
      h4 {
        margin: 20px 0;
        font-size: 25px;
        font-weight: 700;
        padding-left: 2rem;
      }
      h6 {
        margin: 27px 0;
        font-size: 12px;
        font-weight: 500;
      }
      li {
        color: #007A87;
        line-height: 24px;
      }

</style>



// WEBPACK FOOTER //
// src/components/company/Error404.vue